export enum SceneNames {
    PRELOADER = 'PreloaderScene',
    PRELOADER_INFO = 'PreloaderInfoScene',
    LOGO_SCENE = 'LogoScene',
    GAME_SCENE = 'GameScene',
    INTRO_MOVIE_SCENE = 'IntroMovieScene'
}
